import React from "react";
import Buttons from "../Buttons";

import styles from '../styles.module.scss';

export default ({changeBlock}) => {
    return(
        <div className={`${styles.page_block_2} ${styles.block}`}>
            <div className={styles.page_quest_title}>Question 4/4</div>
            <div className={`${styles.page_quest_text} ${styles.text_quest_4}`}>Which age group fits you best?</div>
            <div className={styles.page_quest_checks_wrap}>
                <div className={styles.page_quest_checks_row}>
                    <input id="q4_i1" type="radio" name="q4_i"/>
                    <label htmlFor="q4_i1">18-25</label>
                </div>
                <div className={styles.page_quest_checks_row}>
                    <input id="q4_i2" type="radio" name="q4_i"/>
                    <label htmlFor="q4_i2">26-34</label>
                </div>
                <div className={styles.page_quest_checks_row}>
                    <input id="q4_i3" type="radio" name="q4_i"/>
                    <label htmlFor="q4_i3">35-40</label>
                </div>
                <div className={styles.page_quest_checks_row}>
                    <input id="q4_i4" type="radio" name="q4_i"/>
                    <label htmlFor="q4_i4">41-45</label>
                </div>
                <div className={styles.page_quest_checks_row}>
                    <input id="q4_i5" type="radio" name="q4_i"/>
                    <label htmlFor="q4_i5">45 and upper</label>
                </div>
            </div>
            <Buttons changeBlock={changeBlock} btnName1="NEXT" btnName2="SKIP"/>
        </div>
    )
}